import { router, useGlobalSearchParams } from 'expo-router';
import { useCallback } from 'react';

export const useNavigateWithJwt = () => {
  const { loginJwt } = useGlobalSearchParams<{ loginJwt?: string }>();
  const navigateWithJWT = useCallback(
    (route: string) => {
      router.replace({ pathname: route, params: { loginJwt } });
    },
    [loginJwt]
  );
  return { navigateWithJWT };
};
